export const PropertyFormat = {
  Number: 'Number',
  Text: 'Text',
};
